import {SendHistoryFilterType, useInfiniteAllSendsHistory} from "@twigsby/client-data";
import React, {useContext, useEffect, useMemo, useState} from "react";
import FilterSendsHistoryModal from "../Components/SendsAdmin/Modals/FilterSendsHistoryModal";
import {useLocation, useNavigate} from "react-router-dom";

type SendMailHistoryProviderType = {
    userId?:string;
    pageId?: number;

    children: any;
}

interface SendMailHistoryType {
    filterActive: boolean;
    filterSettings: SendHistoryFilterType;

    status: any;
    data: any;
    error: any;
    isFetchingNextPage: any;
    fetchNextPage: any;
    hasNextPage: any;

    UpdateFilterActive: any;
    HandleFilterChange: any;
    HandleFilterCleared: any;
    HandleFilterRemoved: any;

    userId?: string;
    pageId?: number;
}

const SendMailHistoryContext = React.createContext<SendMailHistoryType>({} as SendMailHistoryType);

const SendMailHistoryProvider = (props: SendMailHistoryProviderType) => {
    const { state } = useLocation();
    const navigate = useNavigate();

    const [ pageId, setPageId] = useState<number>();
    const [ userId, setUserId] = useState<string>();
    const [ filterActive, setFilterActive] = useState<boolean>(false);

    const DefaultFilterOptions = () => {
        let defaultFilterOptions: SendHistoryFilterType = {};

        if(props.userId) {
            defaultFilterOptions.userIds = [props.userId];
        } else if(state && state.userIds) {
            defaultFilterOptions.userIds = [state.userIds];
        }

        if(props.pageId) {
            defaultFilterOptions.pageIds = [props.pageId];
        } else if(state && state.pageIds) {
            defaultFilterOptions.userIds = [state.pageIds];
        }

        return defaultFilterOptions;
    }

    const [ filterSettings, setFilterSettings] = useState<SendHistoryFilterType>(DefaultFilterOptions());

    const {
        status,
        data,
        error,
        isFetchingNextPage,
        fetchNextPage,
        hasNextPage,
    } = useInfiniteAllSendsHistory(filterSettings);

    const UpdateFilterActive = (state: boolean) => {
        setFilterActive(state);
    }

    const CheckDefaultFilterValues = (data: SendHistoryFilterType) => {
        if(data.userIds && props.userId) {
            data.userIds = [...data.userIds, props.userId];
        } else if(props.userId) {
            data.userIds = [props.userId];
        }

        if(data.pageIds && props.pageId) {
            data.pageIds = [...data.pageIds, props.pageId];
        } else if(props.pageId) {
            data.pageIds = [props.pageId];
        }

        return data;
    }

    const HandleFilterChange = (data: SendHistoryFilterType) => {
        setFilterSettings(CheckDefaultFilterValues(data));
    }

    const HandleFilterCleared = () => {
        setFilterSettings(DefaultFilterOptions());
    }

    const HandleFilterRemoved = (key: string) => {
        let newFilters: any = {...filterSettings};

        delete newFilters[key];

        setFilterSettings(newFilters);
    }

    const sendMailHistoryMemo = useMemo(() => {
        return {
            filterActive,
            filterSettings,
            status,
            data,
            error,
            isFetchingNextPage,
            fetchNextPage,
            hasNextPage,
            userId,
            pageId,
            UpdateFilterActive,
            HandleFilterChange,
            HandleFilterCleared,
            HandleFilterRemoved
        }
    }, [
        filterActive,
        filterSettings,
        status,
        data,
        error,
        isFetchingNextPage,
        fetchNextPage,
        hasNextPage,
        userId,
        pageId,
    ]);

    useEffect(() => {
        navigate(window.location.pathname, { replace: true });
        if(props.pageId) {
            setPageId(props.pageId);
        }
        if(props.userId) {
            setUserId(props.userId);
        }
    }, []);

    return (
        <SendMailHistoryContext.Provider value={sendMailHistoryMemo}>
            {props.children}

            <FilterSendsHistoryModal
                filterData={filterSettings}
                isOpen={filterActive}
                hidePageDetails={!!props.pageId}
                hideUserDetails={!!props.userId}
                closeCallback={() => UpdateFilterActive(false)}
                actionedCallback={(filterData: SendHistoryFilterType) => {
                    HandleFilterChange(filterData);
                    UpdateFilterActive(false);
                }}
            />

        </SendMailHistoryContext.Provider>
    )

}

const useSendMailHistory = (pageId?: number, userId?: string) => useContext(SendMailHistoryContext);

export { SendMailHistoryContext, useSendMailHistory };

export default SendMailHistoryProvider
